export default {
	title: '波形定义',
	actions: {
		add: '新增',
		edit: '修改',
		delete: '删除',
		batchDelete: '批量删除'
	},
	messages: {
		deleteConfirm: '确定删除选中的 {count} 项记录吗？',
		deleteSuccess: '操作成功',
		selectDeleteWarning: '请选择要删除的记录',
		operateSuccess: '操作成功',
		requiredFieldCannotBeEmpty: '必填项不能为空'
	},
	form: {
		label: '名称',
		value: '英文代码',
		placeholder: {
			label: '请输入名称',
			value: '请输入英文代码'
		}
	},
	table: {
		id: 'ID',
		label: '名称',
		value: '英文代码',
		unit: '单位',
		sort: '排序'
	},
	dialog: {
		add: '新增',
		edit: '修改',
		cancel: '取消',
		confirm: '确定'
	},
	widgetForm: {
		label: '名称',
		value: '英文代码',
		unit: '单位',
		sort: '排序',
		remark: '备注',
		gridLayout: '格栅布局',
		requiredFieldCannotBeEmpty: '必填项不能为空',
		placeholder: {
			label: '请输入名称',
			value: '请输入英文代码',
			unit: '请输入单位',
			remark: '请输入备注'
		}
	}
}
